export default (title, name) => {
  if (typeof window.tC.event.select_item === "function") {
    window.tC.event.select_item(this, {
      //productName: name,
      item_name: name,
      item_list_name: title,
    });
  }
};
